// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import {
    getActiveUsersByCollaborativeBoards,
    getActiveUsersOnCollaborativeBoardsCount,
} from '../../../../../notifications/liveEditingSelector';
import { getIsSheetOpen } from '../../../../../mobile/structural/sheet/sheetSelectors';

// Components
import NotificationsList from './NotificationsList';
import Tabs from '../../../../../components/tabs/Tabs';
import Tab from '../../../../../components/tabs/Tab';
import PopupList from '../../../../../components/popupPanel/types/PopupList';
import NotificationOptOutPopup from './optOutPopup/NotificationOptOutPopup';
import NotificationEntryLiveEditing from './entry/NotificationEntryLiveEditing';
import RemoteUserCurrentlyViewedBoardManager from '../../../../../utils/collaboration/RemoteUserCurrentlyViewedBoardManager';

// Constants
import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';

// Styles
import './NotificationsList.scss';
import { selectIsMobileAppMode } from '../../../../../platform/platformSelector';

const TABS = {
    NOTIFICATIONS: 'NOTIFICATIONS',
    USERS: 'USERS',
};

const mapStateToProps = createStructuredSelector({
    activeUsersByBoards: getActiveUsersByCollaborativeBoards,
    activeUserCount: getActiveUsersOnCollaborativeBoardsCount,
    isNotificationsSheetOpen: getIsSheetOpen(SheetId.Notifications),
    isMobileAppMode: selectIsMobileAppMode,
});

const NotificationsTabPanels = (props) => {
    const { activeTab, activeUsersByBoards } = props;

    if (activeTab === TABS.NOTIFICATIONS) {
        return (
            <PopupList>
                <NotificationsList {...props} />
            </PopupList>
        );
    }

    return (
        <PopupList>
            {activeUsersByBoards.map((activeUsersByBoardEntry, index) => (
                <NotificationEntryLiveEditing key={index} {...activeUsersByBoardEntry} {...props} />
            ))}
        </PopupList>
    );
};

const NotificationsPopupTabbedContent = (props) => {
    const { notifications, activeUserCount } = props;

    if (!notifications || !notifications.size) return null;

    return (
        <Tabs
            initialActiveTab={TABS.NOTIFICATIONS}
            tabs={[
                <Tab tabId={TABS.NOTIFICATIONS}>Notifications</Tab>,
                <Tab tabId={TABS.USERS} className={activeUserCount ? 'online' : ''} disabled={!activeUserCount}>
                    <span>Online now</span>
                    <span className="count-indicator">{activeUserCount}</span>
                </Tab>,
            ]}
        >
            {(activeTab) => (
                <div className="panel-content">
                    <RemoteUserCurrentlyViewedBoardManager />
                    <NotificationsTabPanels {...props} activeTab={activeTab} />
                    <NotificationOptOutPopup {...props} />
                </div>
            )}
        </Tabs>
    );
};

NotificationsTabPanels.propTypes = NotificationsPopupTabbedContent.propTypes = {
    notifications: PropTypes.object,
    notificationListItems: PropTypes.array,
    newNotificationsCount: PropTypes.number,
    unseenNotificationsCount: PropTypes.number,
    activeUserCount: PropTypes.number,
    dispatchMarkAllNotificationsAsSeen: PropTypes.func,
    activeUsersByBoards: PropTypes.array,
    activeTab: PropTypes.string,
};

export default connect(mapStateToProps)(NotificationsPopupTabbedContent);
